import User from "./User";
import { TransactionalEmail } from "./TransactionalEmail";

export const REMINDER_STATUS = {
  PENDING: "PENDING", //En attente
  IN_PROGRESS: "IN_PROGRESS", // En cours
  SUCCESS: "SUCCESS", // Succès
  ERROR: "ERROR", // Erreur
  SENT: "SENT", // Envoyé
  CLICKED: "CLICKED", // Cliqué
  SPAM: "SPAM", // Spam
  OPEN: "OPEN", // Ouvert
};

export default class Remind {
  constructor({
    id = Number.NaN,
    collaborator = null,
    dateCreated = new Date(),
    dateUpdated = new Date(),
    transactionalEmail = null,
    email = "",
    content = "",
    phoneNumber = "",
    status = REMINDER_STATUS.PENDING,
  } = {}) {
    this.id = id ? Number.parseInt(id) : null;
    this.email = email;
    this.content = content;
    this.phoneNumber = phoneNumber;
    this.status = status;
    this.collaborator = collaborator ? new User(collaborator) : null;
    this.dateCreated = new Date(dateCreated);
    this.dateUpdated = new Date(dateUpdated);
    this.transactionalEmail = transactionalEmail
      ? new TransactionalEmail(transactionalEmail)
      : null;
  }
}
